// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mircophone-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 50vh;
}

.microphone-icon-container {
  display: flex;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  align-items: center;
  margin-right: 10px;
  background-image: linear-gradient(128deg, #ffffff, #647c88);
  position: relative;
  cursor: pointer;
  animation: listening infinite 1.5s;
}

@keyframes listening {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.microphone-icon {
  width: 70%;
  height: 70%;
}

.microphone-status {
  font-size: 22px;
  margin-right: 20px;
  min-width: 215px;
}

.btn {
  border: none;
  padding: 10px 30px;
  margin-right: 10px;
  outline: none;
  cursor: pointer;
  font-size: 20px;
  border-radius: 25px;
  box-shadow: 0px 0px 10px 5px #ffffff1a;
}

.microphone-result-container {
  text-align: center;
  height: 50vh;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
}

.microphone-result-text {
  margin-bottom: 30px;
  width: 70vw;
  overflow-y: auto;
}

.microphone-reset {
  border: 1px solid #fff;
  background: none;
  color: white;
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/components/home/styles/DynamicSearchSpeechRecognition.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2DAA2D;EAC3D,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".mircophone-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 50vh;\n}\n\n.microphone-icon-container {\n  display: flex;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  align-items: center;\n  margin-right: 10px;\n  background-image: linear-gradient(128deg, #ffffff, #647c88);\n  position: relative;\n  cursor: pointer;\n  animation: listening infinite 1.5s;\n}\n\n@keyframes listening {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.microphone-icon {\n  width: 70%;\n  height: 70%;\n}\n\n.microphone-status {\n  font-size: 22px;\n  margin-right: 20px;\n  min-width: 215px;\n}\n\n.btn {\n  border: none;\n  padding: 10px 30px;\n  margin-right: 10px;\n  outline: none;\n  cursor: pointer;\n  font-size: 20px;\n  border-radius: 25px;\n  box-shadow: 0px 0px 10px 5px #ffffff1a;\n}\n\n.microphone-result-container {\n  text-align: center;\n  height: 50vh;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 30px;\n}\n\n.microphone-result-text {\n  margin-bottom: 30px;\n  width: 70vw;\n  overflow-y: auto;\n}\n\n.microphone-reset {\n  border: 1px solid #fff;\n  background: none;\n  color: white;\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
